import React from "react";
import { Link } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const Error404 = ({ location }) => {
  return (
    <Container
      justify="center"
      style={{ textAlign: "center", marginBottom: "200px", marginTop: "100px" }}
    >
      <Row>
        <Col xs={12}>
          <h1>
            We couldn't find the page you were looking for...{" "}
          </h1>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <h3>
            Why not go back to the{" "}
            <Link
              to="/?FID=1000"
              style={{ textDecorationLine: "none" }}
            >
              <Button className="complete-order-btn" aria-label="go-home">
                <i className="fas fa-home"></i>
                <b>{" "}Order Home Page </b>
              </Button>
            </Link>{" "}
            and try there!{" "}
          </h3>
        </Col>
      </Row>
    </Container>
  );
};

export default Error404;
